import _orderBy from 'lodash.orderby';

import { TTemplateType, TTemplatedResponse } from '@cloud-wave/neon-common-lib';

import { TConfig } from 'lib/common/types/Config';

export async function getTemplatedResponses({
  config,
  queueIds,
  type,
  fetch_,
}: {
  config: TConfig;
  queueIds: string[];
  type: TTemplateType;
  fetch_: (url, options?, tokens_?, throwError?) => Promise<any>;
}): Promise<TTemplatedResponse[]> {
  const templateEndpoint = `${config.AGENT_SERVICE_V2_URL}/user/templated-responses?queueIds=${queueIds.join(
    ','
  )}&type=${type}`;
  try {
    const response = await fetch_(templateEndpoint);

    const templatedRes = (await response.json()).data;

    const parsedTemplatedRes = JSON.parse(templatedRes) as TTemplatedResponse[];

    const sortedTemplatedResponses = _orderBy(parsedTemplatedRes, ({ name }) => name.toLowerCase());

    return sortedTemplatedResponses;
  } catch (e) {
    return [];
  }
}
